if(!customElements.get('product-tabs')) {
  class ProductTabs extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.initTabs();
    }

    addMultipleEventListener(element, events, handler) {
      events.forEach(e => element.addEventListener(e, handler))
    }

    initTabs() {
      const tabsContainer = this.querySelector('.tabs__header');
      const tabsLinks = tabsContainer.querySelectorAll('a');

      const tabsContents = this.querySelectorAll('.tab__content'); 

      tabsLinks.forEach((tabLink, index) => {
        this.addMultipleEventListener(
          tabLink,
          ['click', 'focus'],
          (event) => {
            event.preventDefault();

            tabsLinks.forEach((link) => {
              link.parentElement.classList.remove("active");
              if(link === event.target) {
                link.classList.add('active');
              } else {
                link.classList.remove('active');
              }   
            });

            const target = document.querySelector(event.target.dataset.target);
            tabsContents.forEach((tabContent) => {
              if(tabContent === target) {
                tabContent.classList.add('tab--active');
                tabContent.style.minHeight = this.getTheTallestContainersHeight(tabsContents)
              } else {
                tabContent.classList.remove('tab--active');
              }            
            });
          }
        );
      });

      // active first tab by default
      tabsLinks[0].click();
    }

    getTheTallestContainersHeight(contents) {
      let height = 0;

      contents.forEach((el) => {
        if(el.scrollHeight > height && el.getAttribute('id') !== 'product-tab-reviews') {          
          height = el.scrollHeight
        }
      });

      return height + 'px';
    }
  }

  customElements.define('product-tabs', ProductTabs)
}